<template>
  <div class="create">
    <!-- 抬头 -->
    <div class="head">
      <div class="head-left">
        <h4>创建问卷调查</h4>
      </div>
      <div class="head-right">
        <!-- <div class="inputBox">
          <el-input
            :clearable="true"
            placeholder="请输入问卷名称"
            v-model="questionnairesInput"
            clearable
            @change="change"
          >
          </el-input>
          <el-button
            size="medium"
            style="background: #484c7f; color: #fff"
            @click="searchQuestionnaires"
          >搜索</el-button>
        </div> -->
        <div class="head-right-btn">
          <el-button
            size="medium"
            style="background: #258ce8; color: #fff"
            @click="previewQuestionnaire"
          >预览问卷</el-button>
        </div>
        <!-- <div class="head-back">
          <el-button
            size="small"
            type="info"
            @click="backProject"
          >返回</el-button>
        </div> -->
      </div>
    </div>
    <!-- 抬头结束 -->
    <!-- 内容区域 -->
    <div class="contents">
      <!-- //1左侧选择内容 -->
      <div class="contents-left">
        <div class="title">
          <h4 class="title-h4">题型选择</h4>
          <div class="title-rhombus"></div>
        </div>
        <ul class="list">
          <li
            class="list-item"
            v-for="(item,index) in list"
            :key="index"
            @click="listBtn(item,index)"
            @mouseenter="listEnter(item,index)"
            @mouseleave="listLeave(item,index)"
          >
            <div class="list-item-img"><img :src="item.img"></div>
            <div class="list-item-text">{{item.text}}</div>
            <transition-group name="list">
              <!-- v-if="index==listIndex" -->
              <template v-if="index==listIndex">
                <!-- 单选 -->
                <div
                  :key="0"
                  v-show="singleChoiceShow"
                  class="pop-up pop-up-left"
                >
                  <div class="singleChoice">
                    <!-- 顶部标题 -->
                    <div class="pop-up-head">
                      <div class="pop-up-head-img"><img
                          src="../../../assets/image/questionnaires/问题.png"
                        ></div>
                      <h4 class="pop-up-head-text">问题预览</h4>
                    </div>
                    <!-- 中间内容 -->
                    <div class="singleChoice-content">
                      <div class="singleChoice-content-text">单选</div>
                      <div class="singleChoice-content-function">
                        <el-radio label="备选项 A"></el-radio>
                        <el-radio label="备选项 B"></el-radio>
                        <el-radio label="备选项 C"></el-radio>
                      </div>
                    </div>
                    <!-- 底部图片 -->
                    <div class="pop-up-log-img">
                      <div class="pop-up-log-img-box"><img
                          src="../../../assets/image/questionnaires/共识云logo长方.png"
                        ></div>
                    </div>
                  </div>
                </div>
                <!-- 多选   -->
                <div
                  v-show="multipleChoiceShow"
                  :key="1"
                  class="pop-up pop-up-right"
                >
                  <div class="multipleChoice">
                    <!-- 顶部标题 -->
                    <div class="pop-up-head">
                      <div class="pop-up-head-img"><img
                          src="../../../assets/image/questionnaires/问题.png"
                        ></div>
                      <h4 class="pop-up-head-text">问题预览</h4>
                    </div>
                    <!-- 中间内容 -->
                    <div class="multipleChoice-content">
                      <div class="multipleChoice-content-text">多选</div>
                      <div class="multipleChoice-content-function">
                        <el-checkbox label="复选框 A"></el-checkbox>
                        <el-checkbox label="复选框 B"></el-checkbox>
                        <el-checkbox label="复选框 C"></el-checkbox>
                      </div>
                    </div>
                    <!-- 底部图片 -->
                    <div class="pop-up-log-img">
                      <div class="pop-up-log-img-box"><img
                          src="../../../assets/image/questionnaires/共识云logo长方.png"
                        ></div>
                    </div>
                  </div>
                </div>
                <!-- 单框 -->
                <div
                  :key="2"
                  v-show="singleFrameShow"
                  class="pop-up pop-up-left"
                >
                  <div class="singleFrame">
                    <!-- 顶部标题 -->
                    <div class="pop-up-head">
                      <div class="pop-up-head-img"><img
                          src="../../../assets/image/questionnaires/问题.png"
                        ></div>
                      <h4 class="pop-up-head-text">问题预览</h4>
                    </div>
                    <!-- 中间内容 -->
                    <div class="singleFrame-content">
                      <div class="singleFrame-content-text">单框</div>
                      <div class="singleFrame-content-function">
                        <el-input placeholder="请输入内容"></el-input>
                      </div>
                    </div>
                    <!-- 底部图片 -->
                    <div class="pop-up-log-img">
                      <div class="pop-up-log-img-box"><img
                          src="../../../assets/image/questionnaires/共识云logo长方.png"
                        ></div>
                    </div>
                  </div>
                </div>
                <!-- 多框 -->
                <div
                  :key="3"
                  v-show="multiFrameShow"
                  class="pop-up pop-up-right"
                >
                  <div class="multiFrame">
                    <!-- 顶部标题 -->
                    <div class="pop-up-head">
                      <div class="pop-up-head-img"><img
                          src="../../../assets/image/questionnaires/问题.png"
                        ></div>
                      <h4 class="pop-up-head-text">问题预览</h4>
                    </div>
                    <!-- 中间内容 -->
                    <div class="multiFrame-content">
                      <div class="multiFrame-content-text">多框</div>
                      <div class="multiFrame-content-function">
                        <el-input
                          placeholder="请输入内容"
                          class="multiFrame-buttom"
                        ></el-input>
                        <el-input
                          placeholder="请输入内容"
                          class="multiFrame-buttom"
                        ></el-input>
                        <el-input
                          placeholder="请输入内容"
                          class="multiFrame-buttom"
                        ></el-input>
                      </div>
                    </div>
                    <!-- 底部图片 -->
                    <div class="pop-up-log-img">
                      <div class="pop-up-log-img-box"><img
                          src="../../../assets/image/questionnaires/共识云logo长方.png"
                        ></div>
                    </div>
                  </div>
                </div>
                <!-- 下拉 -->
                <div
                  :key="4"
                  v-show="pullDownShow"
                  class="pop-up pop-up-left"
                >
                  <div class="pullDown">
                    <!-- 顶部标题 -->
                    <div class="pop-up-head">
                      <div class="pop-up-head-img"><img
                          src="../../../assets/image/questionnaires/问题.png"
                        ></div>
                      <h4 class="pop-up-head-text">问题预览</h4>
                    </div>
                    <!-- 中间内容 -->
                    <div class="pullDown-content">
                      <div class="pullDown-content-text">下拉</div>
                      <div class="pullDown-content-function">
                        <el-select
                          placeholder="请选择"
                          v-model="hduiashudas"
                          style="width:400px;"
                        >
                          <el-option :value="hduiashudas"></el-option>
                        </el-select>
                      </div>
                    </div>
                    <!-- 底部图片 -->
                    <div class="pop-up-log-img">
                      <div class="pop-up-log-img-box"><img
                          src="../../../assets/image/questionnaires/共识云logo长方.png"
                        ></div>
                    </div>
                  </div>
                </div>
                <!-- 省市区 -->
                <div
                  :key="5"
                  v-show="cityShow"
                  class="pop-up pop-up-right"
                >
                  <div class="city">
                    <!-- 顶部标题 -->
                    <div class="pop-up-head">
                      <div class="pop-up-head-img"><img
                          src="../../../assets/image/questionnaires/问题.png"
                        ></div>
                      <h4 class="pop-up-head-text">问题预览</h4>
                    </div>
                    <!-- 中间内容 -->
                    <div class="city-content">
                      <div class="city-content-text">省市区</div>
                      <div class="city-content-function">
                        <el-select
                          placeholder="省"
                          v-model="hduiashudas"
                          style="width:200px;"
                        >
                        </el-select>
                        <el-select
                          placeholder="市"
                          v-model="hduiashudas"
                          style="width:200px;margin:0 20px;"
                        >
                        </el-select>
                        <el-select
                          placeholder="区"
                          v-model="hduiashudas"
                          style="width:200px;"
                        >
                        </el-select>
                      </div>
                    </div>
                    <!-- 底部图片 -->
                    <div class="pop-up-log-img">
                      <div class="pop-up-log-img-box"><img
                          src="../../../assets/image/questionnaires/共识云logo长方.png"
                        ></div>
                    </div>
                  </div>
                </div>
                <!-- 手机验证 -->
                <div
                  :key="6"
                  v-show="phonesCodeShow"
                  class="pop-up pop-up-left pop-up-top-shouji"
                >
                  <div class="phonesCode">
                    <!-- 顶部标题 -->
                    <div class="pop-up-head">
                      <div class="pop-up-head-img"><img
                          src="../../../assets/image/questionnaires/问题.png"
                        ></div>
                      <h4 class="pop-up-head-text">问题预览</h4>
                    </div>
                    <!-- 中间内容 -->
                    <div class="phonesCode-content">
                      <div class="phonesCode-content-text">手机验证</div>
                      <div class="phonesCode-content-function">
                        <div>
                          <div class="phones-code">
                            <div class="phones-code-text">手机号</div>
                            <div>
                              <el-input
                                style="width:680px;"
                                placeholder="请输入手机号"
                                class="multiFrame-buttom"
                              ></el-input>
                            </div>
                          </div>
                          <!-- 验证码 -->
                          <div>
                            <div class="phones-code-y">
                              <div class="phones-code-flex">
                                <div class="phones-code-text-y">验证码</div>
                                <el-input placeholder="请输入验证码"></el-input>
                              </div>
                              <el-button
                                size="medium"
                                style="background: #258ce8; color: #fff"
                              >发送短信</el-button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- 底部图片 -->
                    <div class="pop-up-log-img">
                      <div class="pop-up-log-img-box"><img
                          src="../../../assets/image/questionnaires/共识云logo长方.png"
                        ></div>
                    </div>
                  </div>
                </div>
                <!-- 段落说明 -->
                <div
                  :key="7"
                  v-show="quillShow"
                  class="pop-up pop-up-right  pop-up-top"
                >
                  <div class="pullDown">
                    <!-- 顶部标题 -->
                    <div class="pop-up-head">
                      <div class="pop-up-head-img"><img
                          src="../../../assets/image/questionnaires/问题.png"
                        ></div>
                      <h4 class="pop-up-head-text">问题预览</h4>
                    </div>
                    <!-- 中间内容 -->
                    <div class="pullDown-content">
                      <div class="pullDown-content-text">段落说明</div>
                      <div class="pullDown-content-function">
                        <quill-editor />
                      </div>
                    </div>
                    <!-- 底部图片 -->
                    <div class="pop-up-log-img">
                      <div class="pop-up-log-img-box"><img
                          src="../../../assets/image/questionnaires/共识云logo长方.png"
                        ></div>
                    </div>
                  </div>
                </div>
                <!-- 文件上传 -->
                <div
                  :key="8"
                  v-show="uploadShow"
                  class="pop-up pop-up-left pop-up-top-xiazai"
                >
                  <div class="pullDown">
                    <!-- 顶部标题 -->
                    <div class="pop-up-head">
                      <div class="pop-up-head-img"><img
                          src="../../../assets/image/questionnaires/问题.png"
                        ></div>
                      <h4 class="pop-up-head-text">问题预览</h4>
                    </div>
                    <!-- 中间内容 -->
                    <div class="pullDown-content">
                      <div class="pullDown-content-text">文件上传</div>
                      <div class="shangchuanwenjian">
                        <el-upload
                          :file-list="fileList"
                          :action="action"
                        >
                          <el-button
                            size="small"
                            type="primary"
                          >点击上传</el-button>
                        </el-upload>
                      </div>
                    </div>
                    <!-- 底部图片 -->
                    <div class="pop-up-log-img">
                      <div class="pop-up-log-img-box"><img
                          src="../../../assets/image/questionnaires/共识云logo长方.png"
                        ></div>
                    </div>
                  </div>
                </div>
              </template>
            </transition-group>
          </li>
        </ul>
      </div>
      <!-- //1左侧选择内容 结束-->
      <!-- //2右侧选择内容 -->
      <div class="contents-right">
        <el-form
          ref="form"
          :model="form"
        >
          <!-- <div v-for="item in 100">{{item}}</div> -->
          <!-- 添加选项弹出框 -->
          <div class="additem">
            <el-dialog
              :title="typeMap[questItem.question_type]"
              :visible.sync="showItem"
              width="50%"
            >
              <el-form-item
                label="标题"
                v-show="questItem.question_type != 'paragraph'"
              >
                <el-input v-model="itemTitle"></el-input>
              </el-form-item>
              <el-form-item
                label="添加选项"
                v-show="questItem.question_type != 'input'
                 && questItem.question_type != 'cascader' 
                 && questItem.question_type != 'phoneValidation'
                 && questItem.question_type != 'paragraph'
                 && questItem.question_type != 'upload'"
              >
                <el-input-number
                  v-model="num"
                  @change="handleChange"
                  :min="1"
                  :max="10"
                ></el-input-number>
              </el-form-item>
              <div class="addSHOW">
                <el-form-item
                  class="addSHOW-x"
                  label="选项"
                  v-for="(text, i) in itemText"
                  :key="i"
                  v-show="questItem.question_type != 'input' 
                && questItem.question_type != 'cascader' 
                && questItem.question_type != 'phoneValidation'
                && questItem.question_type != 'paragraph'
                && questItem.question_type != 'upload'"
                >
                  <!-- <el-input v-model="itemText[i]"></el-input> -->
                  <el-input v-model="itemText[i].option_name"></el-input>
                  <div
                    class="addSHOW-tf"
                    v-if="questItem.question_type=='radio' || questItem.question_type=='checkbox' "
                  >
                    <el-checkbox
                      :true-label="1"
                      :false-label="0"
                      v-model="itemText[i].is_fill"
                    >允许填空</el-checkbox>
                  </div>
                  <div
                    class="addSHOW-tf"
                    v-if="itemText[i].is_fill"
                  >
                    <el-checkbox
                      :true-label="1"
                      :false-label="0"
                      v-model="itemText[i].is_required"
                    >必填</el-checkbox>
                  </div>
                </el-form-item>
              </div>
              <el-form-item
                label="城市选择器"
                v-show="questItem.question_type != 'input'&& questItem.question_type == 'cascader' "
              >
                <el-cascader
                  placeholder="城市选择器"
                  style="width:100%;"
                  disabled
                ></el-cascader>
              </el-form-item>

              <el-form-item
                label="手机验证"
                v-show="questItem.question_type != 'input'&& questItem.question_type == 'phoneValidation' "
              >
                <div style="width:100%;">
                  <el-input
                    v-model="phonesValidationText[0].option_name"
                    placeholder="请输入手机号"
                    disabled
                  ></el-input>

                  <el-input
                    style="margin-top:20px;"
                    v-model="phonesValidationText[1].option_name"
                    placeholder="请输入手机号"
                    disabled
                  ></el-input>
                </div>
              </el-form-item>

              <!-- 弹窗展示富文本 -->
              <el-form-item
                v-show="questItem.question_type != 'input'&& questItem.question_type == 'paragraph' "
              >
                <div style="width:100%;">
                  <!-- 这里是一个富文本 -->
                  <div class="quillEditor">
                    <el-upload
                      class="avatar-uploader"
                      :action="action"
                      name="file"
                      :show-file-list="false"
                      :on-success="uploadSuccess"
                      :before-upload="beforeUpload"
                      :data="{file:'file',model:''}"
                    ></el-upload>
                    <quill-editor
                      class="ql-editor"
                      v-model="quillTitle"
                      :options="editorOption"
                      ref="myQuillEditor"
                      @change="onEditorChange($event)"
                    >
                    </quill-editor>
                  </div>
                </div>
              </el-form-item>
              <!-- 弹窗展示富文本 -->

              <!-- 弹窗上传文件 -->
              <el-form-item
                label="上传文件"
                v-show="questItem.question_type != 'input'&& questItem.question_type == 'upload' "
              >
                <el-button
                  size="small"
                  type="primary"
                >文件上传</el-button>
              </el-form-item>
              <!-- 弹窗上传文件 -->

              <span
                slot="footer"
                class="dialog-footer"
              >
                <el-button @click="clearItem">取 消</el-button>
                <el-button
                  type="primary"
                  @click="determine"
                >确 定</el-button>
              </span>
            </el-dialog>
          </div>
          <!-- 标题 -->
          <div class="contents-right-head">
            <div class="title">
              <h4 class="title-h4">完善问卷信息</h4>
              <div class="title-rhombus-c"></div>
            </div>
            <h4 class="questionnaire-name">问卷名称：</h4>
            <el-form-item>
              <el-input
                placeholder="请输入标题"
                v-model="form.survey_name"
              ></el-input>
            </el-form-item>
          </div>
          <!-- 遍历已创建的选项渲染 -->
          <div
            class="contents-right-item"
            v-for="(item, index) in form.survey_description"
            :key="index"
          >
            <el-form-item :label="(index+1)+':'">
              <div class="item_title">
                <span>{{typeMap[item.question_type]}}</span>

                <span
                  v-if="item.question_type!='paragraph'"
                  v-text="item.question_name"
                ></span>
              </div>
              <!-- 单项填空 -->
              <div v-if="item.question_type==='input'">
                <el-input
                  class="disabled"
                  placeholder="请输入内容"
                  disabled
                ></el-input>
              </div>

              <!-- 单选 -->
              <div
                class="horizontal"
                v-else-if="item.question_type==='radio'"
              >
                <div
                  class="warp-checkbox"
                  v-for="(elm, i) in item.options"
                  :key="i"
                >
                  <!-- :label="(i+1)+'、'" -->
                  <el-radio disabled></el-radio>
                  <!-- <el-input v-model="item.textList[i]"></el-input> -->
                  <div class="warp-checkbox-text">
                    {{item.options[i].option_name}}
                  </div>
                </div>
              </div>

              <!-- 手机验证 -->
              <div v-else-if="item.question_type==='phoneValidation'">
                <div>
                  <div class="phonesCode-content">
                    <div class="phonesCode-content-function">
                      <div>
                        <div class="phones-code">
                          <div class="phones-code-text">手机号</div>
                          <div class="phones-code-input">
                            <el-input
                              style="width:100%;"
                              placeholder="请输入手机号"
                              disabled
                              class="multiFrame-buttom"
                            ></el-input>
                          </div>
                        </div>
                        <!-- 验证码 -->
                        <div style="margin-bottom: 25px;">
                          <div class="phones-code-y">
                            <div class="phones-code-flex">
                              <div class="phones-code-text-y">验证码</div>
                              <el-input
                                placeholder="请输入验证码"
                                disabled
                              ></el-input>
                            </div>
                            <el-button
                              disabled
                              size="medium"
                              style="background: #258ce8; color: #fff"
                            >发送短信</el-button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 富文本 -->
              <div v-else-if="item.question_type==='paragraph'">
                <div v-html="item.question_name"></div>
              </div>
              <!-- 富文本 -->

              <!-- 上传文件 -->
              <div v-else-if="item.question_type==='upload'">
                <el-button
                  size="small"
                  type="primary"
                >文件上传</el-button>
              </div>
              <!-- 上传文件 -->

              <!-- 城市选择 -->
              <div v-else-if="item.question_type==='cascader'">
                <el-cascader
                  style="width:100%;"
                  disabled
                ></el-cascader>
              </div>

              <!-- 多选 -->
              <div
                class="horizontal"
                v-else-if="item.question_type==='checkbox'"
              >
                <div
                  class="warp-checkbox"
                  v-for="(elm, i) in item.options"
                  :key="i"
                >
                  <!--  :label="(i+1)+'、'" -->
                  <el-checkbox disabled></el-checkbox>
                  <!-- <el-input v-model="item.textList[i]"></el-input> -->
                  <div class="warp-checkbox-text">
                    {{item.options[i].option_name}}</div>
                </div>
              </div>

              <!-- 下拉选择 -->
              <div v-else-if="item.question_type === 'select'">
                <el-select
                  v-model="value"
                  placeholder="请选择"
                  disabled
                >
                  <el-option
                    v-for="(elm, i) in item.options"
                    :key="i"
                    :label="item.options[i].option_name"
                    :value="i+''"
                  >
                  </el-option>
                </el-select>
              </div>

              <!-- 矩阵填空 -->
              <div v-else-if="item.question_type==='matrix'">
                <div
                  class=" matrix"
                  v-for="(elm, i) in item.options"
                  :key="i"
                >
                  <span> {{item.options[i].option_name}}：</span>
                  <el-input
                    class="disabled"
                    placeholder="请输入内容"
                    disabled
                  ></el-input>
                </div>
              </div>
              <!-- 上移、下移、删除 -->
              <div style="margin-top: 10px">
                <el-button
                  @click="handleItem('up', item)"
                  v-if="index!=0"
                >上移</el-button>
                <el-button
                  @click="handleItem('down', item)"
                  v-if="index!=form.survey_description.length-1"
                >下移</el-button>
                <el-button @click="handleItem('del', item)">删除</el-button>
                <el-button @click="edit(item, index)">编辑</el-button>
              </div>
            </el-form-item>
          </div>
          <!-- 创建 -->
          <div v-if="this.form.survey_description.length">
            <el-form-item class="on-submit">
              <el-button
                type="primary"
                @click="onSubmit"
              >保存问卷</el-button>
            </el-form-item>
          </div>
        </el-form>
        <!-- 结尾llog -->
        <div
          class="contents-right-ending"
          v-if="this.form.survey_description.length"
        >
          <div class="contents-right-ending-log"><img
              src="../../../assets/image/questionnaires/共识云logo长方.png"
            >
          </div>
          <div class="contents-right-ending-text">您已完成本次问卷，感谢您的帮助与支持</div>
        </div>
      </div>
      <!-- //2右侧选择内容 结束-->
    </div>
    <!-- 内容区域 结束-->
  </div>
</template>   

<script>
import { Quill } from 'vue-quill-editor'
window.Quill = Quill
import { ImageDrop } from 'quill-image-drop-module';
Quill.register('modules/imageDrop', ImageDrop);
import ImageResize from 'quill-image-resize-module'  //添加
Quill.register('modules/imageResize', ImageResize)
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
let Size = Quill.import('attributors/style/size')
Size.whitelist = ['10px', '12px', '16px', '18px', '20px', '30px', '32px']
Quill.register(Size, true)
// 自定义字体类型
var fonts = ['SimSun', 'SimHei', 'Microsoft-YaHei', 'KaiTi', 'FangSong', 'Arial', 'sans-serif']
var Font = Quill.import('formats/font')
Font.whitelist = fonts
Quill.register(Font, true)
const toolbarOptions = [
  ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
  ["blockquote", "code-block"], // 引用  代码块
  [{ header: 1 }, { header: 2 }], // 1、2 级标题
  [{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表
  [{ script: "sub" }, { script: "super" }], // 上标/下标
  [{ indent: "-1" }, { indent: "+1" }], // 缩进
  [{ 'direction': 'rtl' }],                         // 文本方向
  [{ size: ['10px', '12px', false, '16px', '18px', '20px', '30px', '32px'] }], // 字体大小
  [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
  [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
  [{ font: [false, 'SimSun', 'SimHei', 'Microsoft-YaHei', 'KaiTi', 'FangSong', 'Arial', 'sans-serif'] }], // 字体种类
  [{ align: [] }], // 对齐方式
  ["clean"], // 清除文本格式
  ["image",] // 链接、图片、视频
];
export default {
  name: 'create',
  data () {
    return {
      checked: false,
      fileList: [
        { name: '文件列表1', },
        { name: '文件列表2', }
      ],
      quillTitle: '',
      // quillTitleShow:'',
      action: `https://laravel.gongshicloud.com/api/index/upload`,
      questionnairesInput: '', //抬头搜索 
      list: [
        { text: '单选', img: require('../../../assets/image/questionnaires/单选.png') },
        { text: '多选', img: require('../../../assets/image/questionnaires/多选.png') },
        { text: '单框', img: require('../../../assets/image/questionnaires/线框.png') },
        { text: '多框', img: require('../../../assets/image/questionnaires/符号-穿梭框.png') },
        { text: '下拉', img: require('../../../assets/image/questionnaires/下拉选择.png') },
        { text: '省市', img: require('../../../assets/image/questionnaires/地域.png') },
        { text: '手机验证', img: require('../../../assets/image/questionnaires/安全、盾、验证码.png') },
        { text: '段落说明', img: require('../../../assets/image/questionnaires/duanluo.png') },
        { text: '文件上传', img: require('../../../assets/image/questionnaires/shangchuan.png') },
      ],
      ListType: '',
      listIndex: -1,
      singleChoiceShow: false,//单选  
      multipleChoiceShow: false,//多选 
      singleFrameShow: false,//单框 
      multiFrameShow: false,//多框
      pullDownShow: false,//下拉
      cityShow: false,//省市区
      phonesCodeShow: false,//手机 
      quillShow: false,//富文本
      uploadShow: false,//上传文件
      hduiashudas: '',
      //1创建问卷调查
      value: '',
      matrixsNum: 1,
      num: 1,
      form: {
        survey_name: '',
        survey_description: []
      },
      itemTitle: '',
      itemText: [{
        option_name: "",
        id: "",
        survey_id: "",
        question_id: "",
        option_sort: "",
        is_fill: 0,//是否可以输入
        is_required: 0,//是否必填
        value: '',
      }],
      phonesValidationText: [{
        option_name: "手机号",
        id: "",
        survey_id: "",
        question_id: "",
        option_sort: ""
      }, {
        option_name: "验证码",
        id: "",
        survey_id: "",
        question_id: "",
        option_sort: ""
      }],
      uploadText: '',
      questItem: {},
      showItem: false,
      typeMap: {
        radio: '', //单选
        checkbox: '',//多选
        input: '',//问答
        matrix: '',//矩阵问答
        select: '',//选择
        cascader: '',//城市选择器
        phoneValidation: '',//手机验证
        paragraph: '',//富文本
        upload: '',//上传文件

      },
      editIndex: '',
      newForm: {},
      editorOption: {
        modules: {
          imageDrop: true, //图片拖拽
          imageResize: {
            //放大缩小
            displayStyles: {
              backgroundColor: 'black',
              border: 'none',
              color: 'white'
            },
            modules: ['Resize', 'DisplaySize',] //'Toolbar'居中 
          },
          toolbar: {
            container: toolbarOptions, // 工具栏
            handlers: {
              image: function (value) { //编辑器-上传图片
                if (value) {
                  // 调用antd图片上传upload
                  document.querySelector('.avatar-uploader input').click()
                } else {
                  this.quill.format('image', false)
                }
              },
              upload: value => { //编辑器-上传文件
                if (value) {
                  document.querySelector('.uploadFile input').click()
                }
              }
            }
          },
        },
        theme: 'snow',
      }
    }
  },
  //从问卷列表进来清空输入
  beforeRouteEnter: (to, from, next) => {
    next((vm) => {
      if (from.path == '/questionnaires') {
        vm.form = {
          survey_name: '',
          survey_description: []
        }
      }
    })
  },
  methods: {
    //富文本事件
    onEditorChange (e) {
      // console.log('富文本的事件', e)
    },
    beforeUpload (file) { },
    //上传富文本图片
    uploadSuccess (res) {
      // 获取富文本组件实例
      let quill = this.$refs.myQuillEditor.quill
      // 如果上传成功
      if (res) {
        // 获取光标所在位置
        let length = quill.getSelection().index;
        // 插入图片，res为服务器返回的图片链接地址
        quill.insertEmbed(length, 'image', res.data.url)
        // 调整光标到最后 
        quill.setSelection(length + 1)
      } else {
        // 提示信息，需引入Message
        this.$message.error('图片插入失败！')
      }
    },
    //1----------------------------------------------------
    //抬头预览问卷 
    previewQuestionnaire () {
      if (this.form.survey_name == '') {
        this.$message('请输入标题内容');
        return
      }
      if (this.form.survey_description.length == 0) {
        this.$message('至少添加一个选项');
        return
      }
      this.getFormAdd()
    },
    //预览修改数据类型
    getFormAdd () {
      let newForm = {}
      newForm = this.form
      newForm.survey_description = this.form.survey_description.map(item => {
        if (item.question_type == 'input') item.answer = ''
        if (item.question_type == 'matrix') item.answer = []
        if (item.question_type == 'radio') item.answer = ''
        if (item.question_type == 'checkbox') item.answer = []
        if (item.question_type == 'select') item.answer = ''
        if (item.question_type == 'cascader') item.answer = []
        if (item.question_type == 'phoneValidation') item.answer = []
        return item
      })
      let newFormString = JSON.stringify(newForm);
      this.$router.push({
        path: '/questionnaires/preview',
        query: {
          form: newFormString
        }
      })
    },
    //抬头回车  
    change () { },
    //抬头搜索按钮
    searchQuestionnaires () { },
    //题型鼠标经过 
    listEnter (item, index) {
      this.listIndex = index
      if (index == 0) this.singleChoiceShow = true //单选
      if (index == 1) this.multipleChoiceShow = true//多选
      if (index == 2) this.singleFrameShow = true  //单框
      if (index == 3) this.multiFrameShow = true  //多框
      if (index == 4) this.pullDownShow = true  //下拉   
      if (index == 5) this.cityShow = true  //省市区   
      if (index == 6) this.phonesCodeShow = true  //手机 
      if (index == 7) this.quillShow = true  //富文本
      if (index == 8) this.uploadShow = true  //文件上传
    },
    //题型鼠标离开 
    listLeave (item, index) {
      this.listIndex = -1
      if (index == 0) this.singleChoiceShow = false
      if (index == 1) this.multipleChoiceShow = false
      if (index == 2) this.singleFrameShow = false
      if (index == 3) this.multiFrameShow = false
      if (index == 4) this.pullDownShow = false
      if (index == 5) this.cityShow = false
      if (index == 6) this.phonesCodeShow = false
      if (index == 7) this.quillShow = false
      if (index == 8) this.uploadShow = false
    },
    //题型点击
    listBtn (item, index) {
      if (index == 0) this.ListType = 'radio'//单选
      if (index == 1) this.ListType = 'checkbox' //多选
      if (index == 2) this.ListType = 'input'  //单框
      if (index == 3) this.ListType = 'matrix'  //多框
      if (index == 4) this.ListType = 'select'  //下拉  
      if (index == 5) this.ListType = 'cascader'  //城市选择器 
      if (index == 6) this.ListType = 'phoneValidation'  //手机验证 
      if (index == 7) this.ListType = 'paragraph'  //富文本
      if (index == 8) this.ListType = 'upload'  //文件上传
      this.questItem.question_type = this.ListType
      this.showItem = true
      this.num = 1
      this.itemTitle = ''
      this.itemText = [{
        option_name: '',
        id: "",
        survey_id: "",
        question_id: "",
        option_sort: "",
        is_fill: 0,//是否可以输入
        is_required: 0,//是否必填
        value: '',
      }]
      this.quillTitle = ''
    },
    //1创建问卷调查  
    // 增加/减少 子选项
    handleChange (currentValue, oldValue) {
      if (oldValue > currentValue) {
        this.itemText.splice(currentValue, 1)
      } else {
        this.itemText.push({
          option_name: "",
          id: "",
          survey_id: "",
          question_id: "",
          option_sort: "",
          is_fill: 0,//是否可以输入
          is_required: 0,//是否必填
          value: '',
        })
      }
    },
    // 确定将选项添加进列表中进行渲染
    determine () {
      if (this.questItem.question_type == 'input') {
        // 填空
        if (this.itemTitle == '') {
          this.$message('请输入选项的标题内容');
          return
        }
        if (this.editIndex !== '') {
          this.questItem.question_name = this.itemTitle
          this.questItem.options = [];
          this.form.survey_description.splice(this.editIndex, 1, this.questItem)
          this.editIndex = ''
        } else {
          this.questItem.question_name = this.itemTitle;
          this.questItem.options = [];
          this.form.survey_description.push(this.questItem);
        }
        this.clearItem()
      } else if (this.questItem.question_type == 'radio' || this.questItem.question_type == 'checkbox' || this.questItem.question_type == 'matrix' || this.questItem.question_type == 'select') {
        // 单选、多选、矩阵  
        if (this.itemTitle == '') {
          this.$message('请输入选项的标题内容');
          return
        }
        for (var i = 0; i < this.itemText.length; i++) {
          if (this.itemText[i] == '' || this.itemText[i] == undefined) {
            this.$message('请完整输入每个选项内容');
            return
          }
        }
        if (this.editIndex !== '') {
          this.questItem.question_name = this.itemTitle;
          this.questItem.options = this.itemText;
          this.form.survey_description.splice(this.editIndex, 1, this.questItem)
          this.editIndex = ''
        } else {
          this.questItem.question_name = this.itemTitle;
          this.questItem.options = this.itemText;
          this.form.survey_description.push(this.questItem);
        }
        this.clearItem()
      } else if (this.questItem.question_type == 'cascader') {
        // 城市选择
        if (this.itemTitle == '') {
          this.$message('请输入选项的标题内容');
          return
        }
        if (this.editIndex !== '') {
          this.questItem.question_name = this.itemTitle;
          this.questItem.options = [];
          this.form.survey_description.splice(this.editIndex, 1, this.questItem)
          this.editIndex = ''
        } else {
          this.questItem.question_name = this.itemTitle;
          this.questItem.options = [];
          this.form.survey_description.push(this.questItem);
        }
        this.clearItem()
      } else if (this.questItem.question_type == 'phoneValidation') {
        // 手机验证
        if (this.itemTitle == '') {
          this.$message('请输入选项的标题内容');
          return
        }
        if (this.editIndex !== '') {
          this.questItem.question_name = this.itemTitle;
          this.questItem.options = this.phonesValidationText;
          this.form.survey_description.splice(this.editIndex, 1, this.questItem)
          this.editIndex = ''
        } else {
          this.questItem.question_name = this.itemTitle;
          this.questItem.options = this.phonesValidationText;
          this.form.survey_description.push(this.questItem);
        }
        this.clearItem()
      } else if (this.questItem.question_type == 'paragraph') {
        // 富文本 
        if (this.editIndex !== '') {
          // this.questItem.question_name = this.itemTitle;
          // this.questItem.options = this.quillTitle;
          // this.form.survey_description.splice(this.editIndex, 1, this.questItem)
          // this.editIndex = ''
          this.questItem.question_name = this.quillTitle;
          this.questItem.options = [{
            option_name: "",
            id: "",
            survey_id: "",
            question_id: "",
            option_sort: ""
          }];
          this.form.survey_description.splice(this.editIndex, 1, this.questItem)
          this.editIndex = ''
        } else {
          // this.questItem.question_name = this.itemTitle;
          // this.questItem.options = this.quillTitle;
          // this.form.survey_description.push(this.questItem);
          this.questItem.question_name = this.quillTitle;
          this.questItem.options = [{
            option_name: "",
            id: "",
            survey_id: "",
            question_id: "",
            option_sort: ""
          }];
          this.form.survey_description.push(this.questItem);
        }
        this.clearItem()
      } else if (this.questItem.question_type == 'upload') {
        // 上传文件
        if (this.itemTitle == '') {
          this.$message('请输入选项的标题内容');
          return
        }
        if (this.editIndex !== '') {
          this.questItem.question_name = this.itemTitle;
          // this.questItem.options = this.uploadText;
          this.questItem.options = [{
            option_name: "",
            id: "",
            survey_id: "",
            question_id: "",
            option_sort: ""
          }];
          this.form.survey_description.splice(this.editIndex, 1, this.questItem)
          this.editIndex = ''
        } else {
          this.questItem.question_name = this.itemTitle;
          // this.questItem.options = this.uploadText;
          this.questItem.options = [{
            option_name: "",
            id: "",
            survey_id: "",
            question_id: "",
            option_sort: ""
          }];
          this.form.survey_description.push(this.questItem);
        }
        this.clearItem()
      }
    },
    // 编辑
    edit (item, editIndex) {
      console.log(item);
      this.editIndex = editIndex
      if (item.question_type !== 'input') {
        this.num = item.options.length
        this.showItem = true
        this.questItem = item
        this.itemTitle = item.question_name
        if (item.question_type == 'paragraph') {
          this.quillTitle = item.question_name
        }
        this.itemText = []
        this.itemText.push(...item.options)
      } else {
        this.showItem = true
        this.questItem = item
        this.itemTitle = item.question_name
      }
    },
    // 关闭弹窗，清空数据
    clearItem () {
      this.num = 1
      this.itemTitle = ''
      // this.itemText = ['']
      this.itemText = [{
        option_name: '',
        id: "",
        survey_id: "",
        question_id: "",
        option_sort: "",
        is_fill: 0,//是否可以输入
        is_required: 0,//是否必填
        value: '',
      }]
      this.questItem = {}
      this.quillTitle = ''
      this.showItem = false
    },
    // 判断上移、下移、删除
    handleItem (val, item) {
      switch (val) {
        case 'up':
          this.moveUp(item);
          break;
        case 'down':
          this.moveDown(item);
          break;
        case 'del':
          this.delItem(item);
          break;
        default:
          throw new Error("该操作不存在！")
      }
    },
    // 上移 
    moveUp (item) {
      let index = this.form.survey_description.indexOf(item)
      this.form.survey_description.splice(index, 1)
      this.form.survey_description.splice(index - 1, 0, item)
    },
    // 下移
    moveDown (item) {
      let index = this.form.survey_description.indexOf(item)
      this.moveUp(this.form.survey_description[index + 1])
    },
    // 删除
    delItem (item) {
      let index = this.form.survey_description.indexOf(item)
      this.form.survey_description.splice(index, 1)
    },
    // 提交 
    onSubmit () {
      if (this.form.survey_name == '') {
        this.$message('请输入标题内容');
        return
      }
      if (this.form.survey_description.length == 0) {
        this.$message('至少添加一个选项');
        return
      }
      this.submitApi()
    },
    //提交接口
    async submitApi () {
      const { data: data } = await this.$http.post('survery/create', {
        survey_name: this.form.survey_name,
        survey_detail: this.form.survey_description,
        survey_description: ''
      })
      this.$message({
        message: data.message,
        type: 'success'
      });
      this.$router.push('/questionnaires')
    }
  }
}

</script> 
<style lang="less" scoped>
.create {
  height: 100%;
  .head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e8e8e8;
    padding-bottom: 16px;
    margin-bottom: 23px;
    .head-left {
      h4 {
        font-size: 28px;
        color: #212529;
      }
    }
    .head-right {
      display: flex;
      .head-right-btn {
        margin-left: 167px;
      }
      .inputBox {
        flex: 1;
        display: flex;
        /deep/.el-input {
          width: 332px;
          flex: 1;
          margin-right: 16px;
        }
      }
    }

    // .head-back {
    // }
  }

  .contents {
    height: calc(100% - 81px);
    display: flex;
    //左
    .contents-left {
      height: 100%;
      width: 310px; //387
      margin: 5px;
      // padding: 22px 24px;
      padding: 22px 20px;
      margin-right: 25px;
      background: rgba(255, 255, 255, 0.39);
      box-shadow: 0px 0px 10px #d0d3fb;
      border-radius: 8px;

      .list {
        display: flex;
        align-content: center;
        flex-wrap: wrap;
        justify-content: space-between;

        .list-item {
          position: relative;
          padding: 9px 14px;
          border: 1px solid #f2f2f2;
          display: flex;
          align-items: center;
          cursor: pointer;
          margin-bottom: 42px;
          // &:nth-child(odd) {
          //   margin-right: 60px;
          // }
          .list-item-text {
            // padding-left: 12px;
            padding: 0 5px;
            border: 1px solid #f2f2f2;
            color: #484c7f;
            font-size: 14px;
          }
          .list-item-img {
            width: 17px;
            height: 17px;
            margin-right: 12px;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }

        //鼠标经过弹窗
        .pop-up {
          position: absolute;
          top: 0;
          z-index: 99999999;
          padding: 20px 25px;
          background: rgba(255, 255, 255, 1);
          box-shadow: 0px 0px 10px #d0d3fb;
          border-radius: 8px;
        }
        .pop-up-left {
          left: 345px;
        }
        .pop-up-right {
          left: 185px;
        }
        .pop-up-top {
          top: -86px;
        }
        .pop-up-top-shouji {
          top: -76px;
        }
        .pop-up-top-xiazai {
          top: -46px;
        }
        //单选
        .singleChoice {
          width: 762px;
          .singleChoice-content {
            .singleChoice-content-text {
              font-size: 16px;
              color: #484c7f;
              margin-bottom: 17px;
            }
            .singleChoice-content-function {
            }
          }
        }
        //多选
        .multipleChoice {
          width: 762px;
          .multipleChoice-content {
            .multipleChoice-content-text {
              font-size: 16px;
              color: #484c7f;
              margin-bottom: 17px;
            }
            .multipleChoice-content-function {
            }
          }
        }
        //单框
        .singleFrame {
          width: 762px;
          .singleFrame-content {
            .singleFrame-content-text {
              font-size: 16px;
              color: #484c7f;
              margin-bottom: 17px;
            }
            .singleFrame-content-function {
            }
          }
        }

        //多框
        .multiFrame {
          width: 762px;
          .multiFrame-content {
            .multiFrame-content-text {
              font-size: 16px;
              color: #484c7f;
              margin-bottom: 17px;
            }
            .multiFrame-content-function {
              .multiFrame-buttom {
                margin-bottom: 15px;
                &:last-child {
                  margin-bottom: 0;
                }
              }
            }
          }
        }

        //下拉
        .pullDown {
          width: 762px;
          .pullDown-content {
            .pullDown-content-text {
              font-size: 16px;
              color: #484c7f;
              margin-bottom: 17px;
            }
            .pullDown-content-function {
            }
          }
        }

        //省市区
        .city {
          width: 762px;
          .city-content {
            .city-content-text {
              font-size: 16px;
              color: #484c7f;
              margin-bottom: 17px;
            }
            .city-content-function {
            }
          }
        }

        //手机号
        .phonesCode {
          width: 762px;
          .phonesCode-content {
            .phonesCode-content-text {
              font-size: 16px;
              color: #484c7f;
              margin-bottom: 17px;
            }
            .phonesCode-content-function {
              .phones-code {
                display: flex;
                align-items: center;
                .phones-code-text {
                  width: 80px;
                  margin-right: 25px;
                  font-size: 16px;
                  color: #484c7f;
                }
              }

              .phones-code-y {
                margin-top: 15px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                .phones-code-flex {
                  flex: 1;
                  display: flex;
                  align-items: center;
                  margin-right: 25px;
                  .phones-code-text-y {
                    width: 80px;
                    margin-right: 12px;
                    font-size: 16px;
                    color: #484c7f;
                  }
                }
              }
            }
          }
        }

        //弹窗标题
        .pop-up-head {
          display: flex;
          align-items: center;
          margin-bottom: 40px;
          .pop-up-head-img {
            width: 18px;
            height: 18px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          //弹窗log
          .pop-up-head-text {
            font-size: 18px;
            color: #484c7f;
            margin-left: 6px;
          }
        }
        .pop-up-log-img {
          display: flex;
          justify-content: flex-end;
          margin-top: 90px;
          .pop-up-log-img-box {
            width: 128px;
            height: 36px;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
    //右
    .contents-right {
      flex: 1;
      overflow: auto;
      padding: 5px;
      &::-webkit-scrollbar {
        width: 0 !important;
      }
      .contents-right-head {
        padding: 22px 35px;
        margin-bottom: 22px;
        border-radius: 8px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 0px 10px #d0d3fb;
        .questionnaire-name {
          font-size: 16px;
          color: #484c7f;
          margin: 28px 0 35px 0;
        }
      }
      .contents-right-item {
        padding: 33px 35px;
        margin-bottom: 22px;
        border-radius: 8px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 0px 10px #d0d3fb;
      }
      .warp {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
      }
      .warp-checkbox {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
        margin-right: 30px;
      }
      .warp-checkbox-text {
        padding-left: 10px;
      }
      .matrix {
        margin-bottom: 10px;
      }
      .disabled {
        background: #f5f7fa;
      }

      .horizontal {
        display: flex;
      }

      .phones-Validation {
        display: flex;
        .phones-Validation-text {
          width: 80px;
        }
      }

      .phones-Validation-code {
        display: flex;
        .phones-Validation-code-text {
          width: 80px;
        }
        .phones-Validation-code-btn {
          margin-left: 20px;
        }
      }

      // /deep/ .el-radio {
      //   line-height: 40px;
      //   margin-right: 30px;
      // }

      // /deep/ .el-checkbox {
      //   line-height: 40px;
      //   margin-right: 30px;
      // }

      /deep/.el-radio {
        margin-right: 0;
      }

      .on-submit {
        padding: 18px 0 18px 0;
      }

      .contents-right-ending {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 26px 0 58px 0;
        margin-bottom: 22px;
        border-radius: 8px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 0px 10px #d0d3fb;
        .contents-right-ending-log {
          width: 128px;
          height: 36px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .contents-right-ending-text {
          margin-top: 19px;
          color: #484c7f;
          font-size: 16px;
        }
      }

      .additem {
        /deep/ .el-form-item__content {
          display: flex;
        }
        /deep/.el-form-item__label {
          width: 100px;
          text-align: right;
        }
        /deep/.el-dialog__body {
          margin-top: 15px;
        }
      }

      //展示手机验证
      .phonesCode-content-function {
        .phones-code {
          display: flex;
          align-items: center;
          .phones-code-text {
            width: 80px;
            margin-right: 5px;
            font-size: 14px;
            color: #484c7f;
          }
          .phones-code-input {
            flex: 1;
          }
        }

        .phones-code-y {
          margin-top: 15px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .phones-code-flex {
            flex: 1;
            display: flex;
            align-items: center;
            margin-right: 25px;
            .phones-code-text-y {
              width: 80px;
              margin-right: 12px;
              font-size: 14px;
              color: #484c7f;
            }
          }
        }
      }
    }
  }

  .create .contents .contents-right {
    margin-right: 0 !important;
  }
  //平行四边形
  .title {
    position: relative;
    padding-bottom: 24px;
    // border-bottom: 1px solid #f3f3f3;
    .title-h4 {
      position: relative;
      font-size: 18px;
      color: #212529;
      z-index: 10;
    }
    .title-rhombus {
      position: absolute;
      top: 15px;
      left: 15px;
      width: 71px;
      height: 8px;
      background-color: #8ea5ff;
      transform: skew(-25deg);
      z-index: 5;
    }
    .title-rhombus-c {
      position: absolute;
      top: 15px;
      left: 52px;
      width: 71px;
      height: 8px;
      background-color: #8ea5ff;
      transform: skew(-25deg);
      z-index: 5;
    }
  }

  //显示
  .list-enter-active {
    animation: scale-in-hor-center 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)
      both;
  }
  @keyframes scale-in-hor-center {
    0% {
      transform: scaleX(0);
      opacity: 1;
    }
    100% {
      transform: scaleX(1);
      opacity: 1;
    }
  }

  .avatar-uploader {
    position: absolute;
  }
  // /deep/.ql-container {
  //   height: 60px;
  // }

  .shangchuanwenjian {
    position: absolute;
  }

  .addSHOW {
    // display: flex;
    // align-items: center;
  }
  .addSHOW-x {
    flex: 1;
  }
  .addSHOW-tf {
    // width: 50px;
    height: 40px;
    margin-left: 20px;
  }

  .template-shwo {
  }
}
</style>    